import * as templatesApi from 'web-interactives-dashboard-ui/api/templates';
import * as InteractiveApi from 'web-interactives-dashboard-ui/api/interactives';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import I18n from 'I18n';
import usageTracker from 'web-interactives-dashboard-ui/utils/usageTracker';
import { Metrics } from 'web-interactives-dashboard-ui/utils/metricTracker';
import { captureMessage } from 'web-interactives-dashboard-ui/utils/exceptions';
import { redirectToEditor } from 'web-interactives-dashboard-ui/utils/urls';
import { FETCH_TEMPLATES_STARTED, FETCH_TEMPLATES_SUCCEEDED, FETCH_TEMPLATES_FAILED } from './ActionTypes';
import { createInteractiveStart, createInteractiveSuccess, createInteractiveFailure } from './InteractivesActions';
import { getRequestedEditorTour } from '../selectors/appStateSelectors';
export const fetchTemplatesStart = () => ({
  type: FETCH_TEMPLATES_STARTED
});
export const fetchTemplatesSuccess = templates => ({
  type: FETCH_TEMPLATES_SUCCEEDED,
  payload: templates
});
export const fetchTemplatesFailure = err => ({
  type: FETCH_TEMPLATES_FAILED,
  err
});
export const fetchTemplates = () => dispatch => {
  dispatch(fetchTemplatesStart());
  templatesApi.fetchTemplates().then(response => {
    dispatch(fetchTemplatesSuccess(response.results.objects));
  }).catch(err => {
    dispatch(fetchTemplatesFailure(err));
  });
};
export const createInteractive = (templatePath, createdFromIlsListId) => (dispatch, getState) => {
  const showTourOnRedirect = getRequestedEditorTour(getState());
  dispatch(createInteractiveStart());
  InteractiveApi.createInteractive(templatePath, createdFromIlsListId).then(response => {
    dispatch(createInteractiveSuccess(response));
    Metrics.counter('created-interactive-success').increment();
    redirectToEditor(response.id, showTourOnRedirect);
  }).catch(error => {
    FloatingAlertStore.addAlert({
      message: I18n.text('errors.create.message'),
      titleText: I18n.text('errors.create.title'),
      type: 'danger'
    });
    usageTracker.trackCreateInteraction({
      action: 'Create interactive',
      event: 'create-interactive',
      templatePath,
      succeeded: false
    }, false);
    Metrics.counter('created-interactive-failed').increment();
    captureMessage('Error creating interactive', {
      extra: {
        template: templatePath,
        from: 'template',
        code: error && error.code,
        errorCode: error && error.errorCode,
        responseText: error && error.responseText
      }
    });
    dispatch(createInteractiveFailure(error));
  });
};